import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const OrangePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: 'var(--p-orange-50)',
      100: 'var(--p-orange-100)',
      200: 'var(--p-orange-200)',
      300: 'var(--p-orange-300)',
      400: 'var(--p-orange-400)',
      500: 'var(--p-orange-500)',
      600: 'var(--p-orange-600)',
      700: 'var(--p-orange-700)',
      800: 'var(--p-orange-800)',
      900: 'var(--p-orange-900)',
      950: 'var(--p-orange-950)'
    }
  }
});
